import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import { Link , useNavigate } from "react-router-dom";
import { FiEdit } from "react-icons/fi";

const enquiryData = [
    {
        id: 1,
        date: "04-02-2026",
        name: " Kumar",
        email: "xxxxxxx@gmail.com",
        mobile: "98xxxxxx67",
        package: "package name",
        pax: "2 Adults",
    },
    {
        id: 2,
        date: "04-02-2026",
        name: " Sha",
        email: "xxxxxxx@gmail.com",
        mobile: "98xxxxxx67",
        package: "package name",
        pax: "2 Adults",
    },
    {
        id: 3,
        date: "04-02-2026",
        name: "Priyan ",
        email: "xxxxxxx@gmail.com",
        mobile: "98xxxxxx67",
        package: "package name",
        pax: "4 Adults",
    },
    {
        id: 4,
        date: "04-02-2026",
        name: "Aron",
        email: "xxxxxxx@gmail.com",
        mobile: "98xxxxxx67",
        package: "package name ",
        pax: "2 Adults",
    },
];

export default function EnquiryTable() {
   
    const navigate =useNavigate();
   
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 25;


    const filteredData = enquiryData.filter((item) =>
        `${item.name} ${item.email} ${item.package}`
            .toLowerCase()
            .includes(search.toLowerCase())
    );


    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentData = filteredData.slice(
        startIndex,
        startIndex + itemsPerPage
    );

    const changePage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (

        <>
            <div className="breadcrumb-bar mb-2">
                <div className="breadcrumb-left">
                    <Link to="/admin/home" className="breadcrumb-link active">
                        Home
                    </Link>

                    <span className="breadcrumb-separator">|</span>

                    <span className="breadcrumb-link inactive" onClick={() => navigate("/admin/enquiry")}> Enquiry Management</span>
                </div>

                {/* Right: Button */}
                <Button
                    className="add-outlet-btn"
                    onClick={() => navigate("/admin/enquiry")}
                >
                   Enquiry
                </Button>
            </div>

            <Container>
                <div className="d-flex justify-content-between align-items-center mb-3 gap-3 flex-wrap">

                    <h5 className="mb-0" style={{ color: "#2A8F9E" }}>
                        Enquiry Management
                    </h5>

                    <div style={{ minWidth: "260px" }}>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by name, email or package"
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setCurrentPage(1);
                            }}
                        />
                    </div>

                </div>


                {/* Table */}
                <div className="table-responsive common-table-wrapper">
                    <table className="table align-middle common-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Enquiry Date</th>
                                <th>User Details</th>
                                <th>Package</th>
                                <th>No. of Pax</th>
                                <th>Status</th>
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{startIndex + index + 1}</td>
                                        <td>{item.date}</td>

                                        <td>
                                            <div><strong>Name:</strong> {item.name}</div>
                                            <div><strong>Email:</strong> {item.email}</div>
                                            <div><strong>Mobile:</strong> {item.mobile}</div>
                                        </td>

                                        <td>{item.package}</td>
                                        <td>{item.pax}</td>
                                        <td>FollowUp</td>
                                        <td className="text-center align-middle">
                                            <button
                                                className="btn btn-sm"
                                                style={{
                                                    backgroundColor: "#2a6f7a",
                                                    color: "#fff",
                                                    borderRadius: "8px",
                                                    padding: "6px 14px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    fontWeight: "500",
                                                }}
                                            >
                                                Update Status
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center py-4">
                                        No enquiries found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>


                {totalPages > 1 && (
                    <div className="d-flex justify-content-end mt-3 guests-pagination">
                        <button
                            className="btn btn-sm guest-page-btn me-2"
                            onClick={() => changePage(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            Prev
                        </button>

                        {[...Array(totalPages)].map((_, i) => (
                            <button
                                key={i}
                                className={`btn btn-sm guest-page-btn me-2 ${currentPage === i + 1 ? "active" : ""
                                    }`}
                                onClick={() => changePage(i + 1)}
                            >
                                {i + 1}
                            </button>
                        ))}

                        <button
                            className="btn btn-sm guest-page-btn"
                            onClick={() => changePage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            Next
                        </button>
                    </div>
                )}
            </Container>
        </>
    );
}
